// extracted by mini-css-extract-plugin
module.exports = {"community":"community_community__21KJF","card_wrapper":"community_card_wrapper__3s7A2"};